"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weightUnit = exports.weightStones = exports.weightPounds = exports.weightMetric = exports.weightField = exports.weightComponent = exports.heightWeightConfig = exports.heightUnit = exports.heightMetric = exports.heightInches = exports.heightField = exports.heightFeet = exports.heightComponent = exports.HeightWeightDefinition = void 0;

var _types = require("../../types");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _config = require("../config");

var _field = require("../../types/field");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// import { range } from '../utils';
// TODO imported range function has a dependency on React
var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _field.FieldElementDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.RadioDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.SelectDefinition;
});

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var HeightWeightDefinition = _flowRuntime["default"].type("HeightWeightDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("heightWeight")))));

exports.HeightWeightDefinition = HeightWeightDefinition;

var range = function range(start, end) {
  var rangeArray = [];

  for (var i = start; i <= end; i += 1) {
    rangeArray.push(i);
  }

  return rangeArray;
};

var heightField = {
  key: 'height',
  title: 'Height',
  type: 'select',
  validation: [{
    required: true
  }]
};
exports.heightField = heightField;
var heightComponent = {
  key: 'height',
  title: 'Height',
  type: 'select'
};
exports.heightComponent = heightComponent;
var weightField = {
  key: 'weight',
  title: 'Weight',
  type: 'select',
  validation: [{
    required: true
  }]
};
exports.weightField = weightField;
var weightComponent = {
  key: 'weight',
  title: 'Weight',
  type: 'select'
};
exports.weightComponent = weightComponent;
var heightUnit = {
  key: 'heightUnit',
  label: 'Height',
  type: 'radio',
  items: [{
    key: 'metric',
    label: 'Metric'
  }, {
    key: 'imperial',
    label: 'Imperial'
  }],
  ui: {
    classes: 'small'
  },
  validation: []
};
exports.heightUnit = heightUnit;
var heightMetricRange = range(140, 210).map(function (item) {
  return {
    key: item.toString(),
    label: item.toString()
  };
});
var heightMetric = {
  key: 'heightMetric',
  type: 'select',
  placeholder: 'Cm',
  ui: {
    classes: 'col span_8_of_12'
  },
  items: heightMetricRange,
  validation: []
};
exports.heightMetric = heightMetric;
var heightFeetRange = range(4, 7).map(function (item) {
  return {
    key: item.toString(),
    label: item.toString()
  };
});
var heightFeet = {
  key: 'heightFeet',
  type: 'select',
  placeholder: 'Feet',
  ui: {
    classes: 'col span_4_of_12'
  },
  items: heightFeetRange,
  validation: []
};
exports.heightFeet = heightFeet;
var heightInchesRange = range(0, 11).map(function (item) {
  return {
    key: item.toString(),
    label: item.toString()
  };
});
var heightInches = {
  key: 'heightInches',
  type: 'select',
  placeholder: 'Inches',
  ui: {
    classes: 'col span_4_of_12'
  },
  items: heightInchesRange,
  validation: []
};
exports.heightInches = heightInches;
var weightUnit = {
  key: 'weightUnit',
  label: 'Weight',
  type: 'radio',
  items: [{
    key: 'metric',
    label: 'Metric'
  }, {
    key: 'imperial',
    label: 'Imperial'
  }],
  ui: {
    classes: 'small'
  },
  validation: []
};
exports.weightUnit = weightUnit;
var weightMetricRange = range(50, 125).map(function (item) {
  return {
    key: item.toString(),
    label: item.toString()
  };
});
var weightMetric = {
  key: 'weightMetric',
  type: 'select',
  placeholder: 'Kg',
  ui: {
    classes: 'col span_8_of_12'
  },
  items: weightMetricRange,
  validation: []
};
exports.weightMetric = weightMetric;
var weightStonesRange = range(7, 25).map(function (item) {
  return {
    key: item.toString(),
    label: item.toString()
  };
});
var weightStones = {
  key: 'weightStones',
  type: 'select',
  placeholder: 'Stones',
  ui: {
    classes: 'col span_4_of_12'
  },
  items: weightStonesRange,
  validation: []
};
exports.weightStones = weightStones;
var weightPoundsRange = range(0, 13).map(function (item) {
  return {
    key: item.toString(),
    label: item.toString()
  };
});
var weightPounds = {
  key: 'weightPounds',
  type: 'select',
  placeholder: 'Pounds',
  ui: {
    classes: 'col span_4_of_12'
  },
  items: weightPoundsRange,
  validation: []
};
exports.weightPounds = weightPounds;
var heightWeightConfig = {
  type: 'heightWeight',
  fields: [heightField, heightMetric, heightFeet, heightInches, weightField, weightMetric, weightStones, weightPounds]
};
exports.heightWeightConfig = heightWeightConfig;